import React from 'react'
import { CButton, CModal, CModalBody, CModalHeader, CModalTitle, CModalFooter } from '@coreui/react';
import { Flex,  Select, Typography } from 'antd';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import {getClubs, getScheduleClients, getUsers} from 'src/store/Slices/DropDownSlice';
import {scheduleUserAction} from "../../../../store/Slices/Administrator/ScheduleSlice";
import { getClientsList } from 'src/store/Slices/ClientsSlice';

const AddEditScheduleUsersModal = ({ visible, setVisible, scheduleInfo, userInfo, setPage, setPageSize, clubId }) => {

  const dispatch = useDispatch()
  const users = useSelector(state => state.DropDownSlice.users)
  const usersLoading = useSelector(state => state.DropDownSlice.usersLoading)
  const [username, setUsername] = useState()
  const [userId, setUserId] = useState()

  useEffect(() => {
    setUsername()
    setUserId()
  }, [visible.flag])


  useEffect(() => {
    if (visible.flag === 'edit') {
      setUserId(userInfo.id)
      setUsername(userInfo.name)
    }
  }, [visible, scheduleInfo, userInfo])

  useEffect(() => {
    dispatch(getUsers({clubId: clubId}))
  }, []);

  const onClickSubmit = () => {
    dispatch(scheduleUserAction({
      flag: visible.flag === 'add' ? 'put' : 'post', value: {
        id: visible.flag === 'add' ? scheduleInfo.id : userInfo.id,
        userId: userId
      }
    })).then(() => {
      dispatch(scheduleUserAction({ flag: 'get', value: { id: scheduleInfo.id } })).then(() => {
        setVisible({ open: false, flag: '' })
        setPage(1)
        setPageSize(20)
      })
    })
  }

  const handleSearch = (value) => {
    dispatch(getUsers({search: value, clubId: clubId}))
  }

  const debounce = () => {
    let timer
    return function(...args) {
      clearTimeout(timer)
      timer = setTimeout(() => handleSearch(...args), 300)
    }
  }

  const handleSearchDebounce = debounce()

  return (
    <CModal
      alignment="center"
      visible={visible.open}
      aria-labelledby="VerticallyCenteredExample"
      onClose={() => { setVisible({ open: false, flag: '' }) }}
      keyboard={true}
    >
      <CModalHeader>
        <CModalTitle id="VerticallyCenteredExample">{
          visible.flag === 'add' ? 'Добавить пользователя' : 'Редактировать пользователя'
        }</CModalTitle>
      </CModalHeader>
      <CModalBody style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>

        <Flex vertical gap={10} style={{ marginTop: '20px' }}>
          <>
            <div>
              <Typography.Title level={5}>Пользователи</Typography.Title>
              <Select
                showSearch
                placeholder='Выбрать'
                style={{ width: '100%' }}
                value={username}
                filterOption={(input, option) =>
                  (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                onSearch={(e) => handleSearchDebounce(e)}
                onChange={e => {
                  setUserId(e)
                  setUsername(e)
                }}
                loading={usersLoading}
                onClick={() => {
                  visible.flag === 'add' && dispatch(getUsers({clubId: clubId}))
                }}
                options={users?.data?.value}
              />
            </div>
          </>
        </Flex>

      </CModalBody>
      <CModalFooter>
        <CButton
          onClick={() => { setVisible({ open: false, flag: '' }) }}
          className='text-light'
          color="secondary"
        >
          Закрыть
        </CButton>
        <CButton onClick={onClickSubmit} className='text-light'>
          {visible.flag === 'add' ? 'Добавить' : 'Редактировать'}
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default AddEditScheduleUsersModal